import { Box, Tooltip } from '@mui/material';
// @mui
import { alpha, useTheme } from '@mui/material/styles';

// utils
import { bgBlur } from '../../../utils/cssStyles';
//
import { IconButtonAnimate } from '../../animate';
import SvgColor from '../../svg-color';
//
import BadgeDot from './BadgeDot';

// ----------------------------------------------------------------------

type Props = {
  notDefault: boolean;
  onToggle: VoidFunction;
  open: boolean;
};

const ToggleButton = ({ notDefault, onToggle, open }: Props) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRadius: '50%',
        bottom: 24,
        boxShadow: `-12px 12px 32px -4px ${alpha(
          theme.palette.mode === 'light'
            ? theme.palette.grey[600]
            : theme.palette.common.black,
          0.36
        )}`,
        p: 0.5,
        position: 'fixed',
        right: 24,
        zIndex: 999,
        ...bgBlur({ color: theme.palette.background.default }),
      }}
    >
      {notDefault && !open && (
        <BadgeDot
          sx={{
            right: 10,
            top: 8,
          }}
        />
      )}

      <Tooltip title="Settings">
        <IconButtonAnimate color="primary" onClick={onToggle} sx={{ p: 1.25 }}>
          <SvgColor src="/assets/icons/setting/ic_setting.svg" />
        </IconButtonAnimate>
      </Tooltip>
    </Box>
  );
};

export default ToggleButton;
